// Angular import
import { AfterViewInit, Component, inject } from "@angular/core";
import { CommonModule, Location, LocationStrategy } from "@angular/common";
import { RouterModule } from "@angular/router";
import { ChangeDetectorRef } from "@angular/core";

// Project import
import { BerryConfig } from "src/app/app-config";

import { NavBarComponent } from "./nav-bar/nav-bar.component";
import { NavigationComponent } from "./navigation/navigation.component";

@Component({
  selector: "app-admin",
  imports: [CommonModule, NavigationComponent, NavBarComponent, RouterModule],
  templateUrl: "./admin.component.html",
  styleUrl: "./admin.component.scss",
})
export class AdminComponent implements AfterViewInit {
  private location = inject(Location);
  private locationStrategy = inject(LocationStrategy);
  cdr = inject(ChangeDetectorRef);

  // public props
  currentLayout!: string;
  navCollapsed = true;
  navCollapsedMob = false;
  windowWidth!: number;

  ngAfterViewInit() {
    let current_url = this.location.path();
    const baseHref = this.locationStrategy.getBaseHref();
    if (baseHref) {
      current_url = baseHref + this.location.path();
    }

    if (
      current_url === baseHref + "/layout/theme-compact" ||
      current_url === baseHref + "/layout/box"
    ) {
      BerryConfig.isCollapse_menu = true;
    }

    this.windowWidth = window.innerWidth;
    this.navCollapsed =
      this.windowWidth >= 1025 ? BerryConfig.isCollapse_menu : false;
    this.cdr.detectChanges();
  }

  // private method
  private isThemeLayout(layout: string) {
    this.currentLayout = layout;
  }

  // public method
  navMobClick() {
    this.navCollapsedMob = !this.navCollapsedMob;

    // Quitamos la clase de colapso si estamos abriendo el menú en móvil
    if (this.navCollapsedMob) {
      this.navCollapsed = false;
    }
  }

  handleKeyDown(event: KeyboardEvent): void {
    if (event.key === "Escape") {
      this.closeMenu();
    }
  }

  closeMenu() {
    if (
      document
        .querySelector("app-navigation.pc-sidebar")
        ?.classList.contains("mob-open")
    ) {
      document
        .querySelector("app-navigation.pc-sidebar")
        ?.classList.remove("mob-open");
    }
  }
}
